import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "bg-container" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "header-info" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "summary-badge" }
const _hoisted_10 = { class: "refresh-time-info" }
const _hoisted_11 = { class: "right-actions" }
const _hoisted_12 = { class: "nav-dropdown" }
const _hoisted_13 = { class: "sort-controls" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "dish-cards" }
const _hoisted_16 = { class: "dish-header" }
const _hoisted_17 = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1"
}
const _hoisted_18 = { class: "dish-name break-words" }
const _hoisted_19 = { class: "break-all text-sm text-gray-600" }
const _hoisted_20 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_21 = { class: "time-info" }
const _hoisted_22 = {
  key: 1,
  class: "dish-title"
}
const _hoisted_23 = { class: "dish-name" }
const _hoisted_24 = { class: "dish-status" }
const _hoisted_25 = {
  key: 0,
  class: "serving-dine-type"
}
const _hoisted_26 = {
  key: 1,
  class: "urgent-badge"
}
const _hoisted_27 = { class: "dish-content" }
const _hoisted_28 = ["src", "alt", "onError"]
const _hoisted_29 = { class: "order-info" }
const _hoisted_30 = { class: "serving-meta" }
const _hoisted_31 = { class: "serving-table" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 2,
  class: "serving-pickup"
}
const _hoisted_35 = {
  key: 0,
  class: "fas fa-fire",
  "aria-hidden": "true"
}
const _hoisted_36 = {
  key: 1,
  class: "fas fa-bell",
  "aria-hidden": "true"
}
const _hoisted_37 = {
  key: 4,
  class: "serving-operation is-paused"
}
const _hoisted_38 = { class: "serving-food-line" }
const _hoisted_39 = {
  key: 0,
  class: "serving-food-name"
}
const _hoisted_40 = { class: "serving-quantity" }
const _hoisted_41 = {
  key: 1,
  class: "serving-food-detail"
}
const _hoisted_42 = {
  key: 2,
  class: "serving-food-detail"
}
const _hoisted_43 = { class: "order-actions" }
const _hoisted_44 = ["disabled", "title", "onClick"]
const _hoisted_45 = { class: "empty-state" }

import { ref, computed, onMounted, watch, onUnmounted } from 'vue';
  import { useRestaurantKitchen } from '@/composables/useRestaurantKitchen';
  import { fetchRestaurantKitchenFoods } from '@/service/restaurantKitchen';
  import { outFood } from '@/service/food';
  import type { KitchenServingItemModel, KitchenServingGroupModel } from '@/model/kitchenServing';

  // 新增：新订单提示音
  const LAST_ORDER_CREATE_TIME_PREFIX = 'kitchen_serving_last_create_time_';
  
export default /*@__PURE__*/_defineComponent({
  __name: 'KitchenServingView',
  setup(__props) {

  let newOrderAudio: HTMLAudioElement | null = null;
  const initNewOrderAudio = () => {
    try {
      const src = new URL('@/assets/audio/new_order.mp3', import.meta.url).href;
      newOrderAudio = new Audio(src);
      newOrderAudio.preload = 'auto';
      newOrderAudio.volume = 1.0;
    } catch (e) {
      console.warn('新订单提示音初始化失败:', e);
    }
  };
  const playNewOrderSound = async () => {
    try {
      if (newOrderAudio) {
        newOrderAudio.currentTime = 0;
        await newOrderAudio.play();
      }
    } catch (e) {
      console.warn('播放新订单提示音失败:', e);
    }
  };

  // 新增：本地存储最近订单创建时间（按厨房）
  const getLastCreateTimeKey = (kitchenId: string) =>
    `${LAST_ORDER_CREATE_TIME_PREFIX}${currentShop.value}_${kitchenId}`;
  const getStoredLastCreateTime = (kitchenId: string): number | null => {
    try {
      const v = localStorage.getItem(getLastCreateTimeKey(kitchenId));
      return v ? parseInt(v, 10) : null;
    } catch {
      return null;
    }
  };
  const setStoredLastCreateTime = (kitchenId: string, ms: number) => {
    try {
      localStorage.setItem(getLastCreateTimeKey(kitchenId), String(ms));
    } catch (e) {
      console.warn('无法保存最近创建时间到localStorage:', e);
    }
  };

  const {
    shops,
    currentShop,
    kitchens,
    currentKitchen,
    selectionVersion,
    selectionLoading,
    selectionMessage,
    loadShops,
  } = useRestaurantKitchen('kitchen_serving_selected_kitchen');
  const lastRefreshTime = ref('');
  let autoRefreshTimer: NodeJS.Timeout | null = null;
  const showNavMenu = ref(false);
  const sortOptions = [
    { value: 'order', label: '按订单排序', icon: 'fas fa-receipt' },
    { value: 'time', label: '按时间排序', icon: 'fas fa-clock' },
    { value: 'priority', label: '按优先级排序', icon: 'fas fa-exclamation-triangle' },
  ];
  const currentSortBy = ref('order');
  const servingIds = ref(new Set<string>());
  const failedImageIds = ref(new Set<string>());

  // 两种展示模式共用逐份菜品数据，出菜后同步更新。
  const servingItems = ref<KitchenServingItemModel[]>([]);

  function splitMultipleQuantityOrders(
    orders: KitchenServingItemModel[],
  ): KitchenServingItemModel[] {
    return orders.flatMap((order) =>
      Array.from({ length: Math.max(1, order.quantity) }, (_, index) => ({
        ...order,
        id: `${order.orderOutId}:${index}`,
        quantity: 1,
      })),
    );
  }

  function getOrderTimeMs(orderTime: string): number {
    const time = new Date(orderTime).getTime();
    return Number.isNaN(time) ? Number.MAX_SAFE_INTEGER : time;
  }

  function getEarliestOrder(orders: KitchenServingItemModel[]): KitchenServingItemModel {
    return orders.reduce((earliest, order) =>
      getOrderTimeMs(order.orderTime) < getOrderTimeMs(earliest.orderTime) ? order : earliest,
    );
  }

  const dishesData = computed<KitchenServingGroupModel[]>(() => {
    const grouped = new Map<string, KitchenServingGroupModel>();
    servingItems.value.forEach((order) => {
      const key = `dish:${order.name}`;
      let group = grouped.get(key);
      if (!group) {
        group = { key, name: order.name, type: order.type, typeName: order.typeName, orders: [] };
        grouped.set(key, group);
      }
      group.orders.push(order);
    });
    return [...grouped.values()];
  });

  const orderGroups = computed<KitchenServingGroupModel[]>(() => {
    const grouped = new Map<number, KitchenServingGroupModel>();
    servingItems.value.forEach((order) => {
      let group = grouped.get(order.orderId);
      if (!group) {
        group = {
          key: `order:${order.orderId}`,
          name: order.name,
          type: order.type,
          typeName: order.typeName,
          orderId: order.orderId,
          orderNo: order.orderNo,
          table: order.table,
          orders: [],
        };
        grouped.set(order.orderId, group);
      }
      group.orders.push(order);
    });
    return [...grouped.values()]
      .map((group) => ({ ...group, orderTime: getEarliestOrder(group.orders).orderTime }))
      .sort(
        (a, b) =>
          getOrderTimeMs(a.orderTime) - getOrderTimeMs(b.orderTime) ||
          (a.orderId ?? 0) - (b.orderId ?? 0),
      );
  });

  const sortedDishes = computed(() => {
    const sorted = [...dishesData.value];
    switch (currentSortBy.value) {
      case 'order':
        return orderGroups.value;
      case 'time':
        return sorted.sort((a, b) => {
          const aEarliest = Math.min(...a.orders.map((o) => new Date(o.orderTime).getTime()));
          const bEarliest = Math.min(...b.orders.map((o) => new Date(o.orderTime).getTime()));
          return aEarliest - bEarliest;
        });
      case 'priority':
        return sorted.sort((a, b) => {
          const aUrgent = a.orders.some((o) => o.isUrgent);
          const bUrgent = b.orders.some((o) => o.isUrgent);
          if (aUrgent !== bUrgent) return Number(bUrgent) - Number(aUrgent);
          const aMaxPriority = Math.max(...a.orders.map((o) => o.priority));
          const bMaxPriority = Math.max(...b.orders.map((o) => o.priority));
          return bMaxPriority - aMaxPriority;
        });
      default:
        return sorted;
    }
  });

  const totalDishes = computed(() => servingItems.value.length);

  function getElapsedTime(orderTime: string) {
    const now = new Date();
    const order = new Date(orderTime);
    if (Number.isNaN(order.getTime())) return '时间未知';
    const diffMs = Math.max(0, now.getTime() - order.getTime());
    const diffMins = Math.floor(diffMs / 60000);
    return `${diffMins}分钟`;
  }

  function isServingPaused(order: KitchenServingItemModel): boolean {
    return order.operateStatus === 1 || order.kitchenStatus === 9;
  }

  function dishCardClass(dish: KitchenServingGroupModel) {
    const hasUrgent = dish.orders.some((order) => order.isUrgent);
    const hasReady = dish.orders.some((order) => order.status === 'ready');
    const hasCooking = dish.orders.some((order) => order.status === 'cooking');
    let overallStatus = 'waiting';
    if (hasReady) overallStatus = 'ready';
    else if (hasCooking) overallStatus = 'cooking';
    return [hasUrgent ? 'urgent' : '', overallStatus];
  }

  function changeSort(sortBy: string) {
    currentSortBy.value = sortBy;
  }

  // 新增：导航菜单切换方法
  const toggleNavMenu = () => {
    showNavMenu.value = !showNavMenu.value;
  };

  // 新增：导航跳转方法
  const goToDishAssignment = () => {
    window.location.href = '/dishAssignment';
    showNavMenu.value = false; // 关闭菜单
  };

  const goToKitchenOrder = () => {
    window.location.href = '/kitchenOrder';
    showNavMenu.value = false; // 关闭菜单
  };

  const goToServingHistory = () => {
    window.location.href = '/servingHistory';
    showNavMenu.value = false; // 关闭菜单
  };

  const goToOrderHistory = () => {
    window.location.href = '/orderHistory';
    showNavMenu.value = false; // 关闭菜单
  };

  const goToTableManage = () => {
    window.location.href = '/tableManage';
    showNavMenu.value = false; // 关闭菜单
  };

  // 厨房相关方法
  // 加载菜品列表
  let foodRequest = 0;
  const loadFoodList = async () => {
    if (!currentKitchen.value) {
      return;
    }

    const version = selectionVersion.value;
    const request = ++foodRequest;
    try {
      const kitchenIds =
        currentKitchen.value === 'all'
          ? kitchens.value.map((item) => Number(item.id))
          : [Number(currentKitchen.value)];
      const details = await fetchRestaurantKitchenFoods(Number(currentShop.value), kitchenIds);
      if (version !== selectionVersion.value || request !== foodRequest) return;
      const apiOrders: KitchenServingItemModel[] = [];
      details.forEach((detail) => {
        const priority = Number(detail.priority) || 1;
        const operateStatus = Number(detail.operateStatus) || 0;
        const order: KitchenServingItemModel = {
          id: `${detail.orderOutId}`,
          orderOutId: detail.orderOutId,
          orderNo: detail.orderNo,
          kitchenId: detail.kitchenId,
          kitchenName: detail.kitchenName,
          kitchenStatus: Number(detail.kitchenStatus),
          imageUrl: detail.imageUrl,
          selfPickDate: detail.selfPickDate,
          selfPickTime: detail.selfPickTime,
          name: detail.shopFoodName || detail.foodName || '',
          type: getFoodTypeString(detail.foodType),
          typeName: getFoodTypeName(detail.foodType),
          table: detail.tableName || '未知桌号',
          quantity: detail.quantity || 1,
          orderTime: detail.createTime || '',
          status: detail.kitchenStatus === 8 ? 'ready' : 'cooking',
          stove: detail.stoveName || '未知灶台',
          isUrgent: operateStatus === 10 || priority >= 999,
          priority,
          operateStatus,
          foodSpecName: detail.foodSpecName || '', // 添加规格名称
          foodCookDesc: detail.foodCookDesc || '', // 添加口味描述
          dineType: detail.dineType || 0, // 添加用餐类型
          // 保存API所需字段
          orderId: detail.orderId,
          orderFoodId: detail.orderFoodId,
          shopId: detail.shopId,
          shopFoodId: detail.shopFoodId,
        };
        apiOrders.push(order);
      });

      // 更新数据
      const splitOrders = splitMultipleQuantityOrders(apiOrders);
      failedImageIds.value.clear();
      servingItems.value = splitOrders;

      // 新增：检查是否有新订单，播放提示音
      if (apiOrders.length > 0) {
        // 找到最晚的创建时间
        let latestCreateTime = 0;
        apiOrders.forEach((order) => {
          const createTime = new Date(order.orderTime || '').getTime();
          if (!Number.isNaN(createTime) && createTime > latestCreateTime) {
            latestCreateTime = createTime;
          }
        });

        if (latestCreateTime > 0) {
          const kitchenId = currentKitchen.value;
          const prev = getStoredLastCreateTime(kitchenId);
          if (prev !== null && latestCreateTime > prev) {
            showToast('您有新的订单，请注意查收');
            playNewOrderSound();
          }
          setStoredLastCreateTime(kitchenId, latestCreateTime);
        }
      }
    } catch (error) {
      if (version !== selectionVersion.value || request !== foodRequest) return;
      showToast('加载菜品失败，请重试');
      console.error('菜品列表加载异常:', error);
      // 异常时清空列表
      servingItems.value = [];
    }
  };

  // 菜品类型映射
  const getFoodTypeString = (foodType: number) => {
    switch (foodType) {
      case 1:
        return 'hot';
      case 2:
        return 'cold';
      case 3:
        return 'soup';
      case 4:
        return 'dim-sum';
      case 5:
        return 'drink';
      default:
        return 'hot';
    }
  };

  const getFoodTypeName = (foodType: number) => {
    switch (foodType) {
      case 1:
        return '热菜';
      case 2:
        return '冷菜';
      case 3:
        return '汤类';
      case 4:
        return '点心';
      case 5:
        return '饮品';
      default:
        return '热菜';
    }
  };

  // 用餐类型映射
  const getDineTypeText = (dineType: number) => {
    switch (dineType) {
      case 1:
        return '堂食';
      case 2:
        return '自提';
      case 3:
        return '外卖';
      case 4:
        return '打包';
      default:
        return '未知';
    }
  };

  // 小票相关
  const showReceiptModal = ref(false);
  const receiptOrder = ref<KitchenServingItemModel | null>(null);
  const receiptOrderTime = ref('');

  async function serveOrder(order: KitchenServingItemModel) {
    if (servingIds.value.has(order.id)) return;
    const latestOrder = servingItems.value.find((item) => item.id === order.id);
    if (!latestOrder) return;
    if (latestOrder.operateStatus === 1) {
      showToast('服务员已暂停该菜品，恢复后才可出菜');
      return;
    }
    const version = selectionVersion.value;

    // 数据验证
    if (!order.orderId || !order.orderFoodId || !order.shopId) {
      console.error('出餐失败：缺少必要的API参数', {
        orderId: order.orderId,
        orderFoodId: order.orderFoodId,
        shopId: order.shopId,
      });
      alert('出餐失败：数据异常，请刷新后重试');
      return;
    }

    servingIds.value.add(order.id);

    try {
      // 调用出餐API
      const response = await outFood({
        orderId: order.orderId,
        orderFoodId: order.orderFoodId,
        shopId: order.shopId,
      });

      if (version !== selectionVersion.value) return;
      if (response.code === 200) {
        console.log('出餐成功:', response);

        // 记录小票信息
        // receiptOrder.value = { ...order, dishName: dish.name, dishTypeName: dish.typeName };
        // receiptOrderTime.value = new Date().toLocaleString();
        // showReceiptModal.value = true;

        servingItems.value = servingItems.value.filter((item) => item.id !== order.id);

        // 可选：刷新数据
        setTimeout(() => {
          loadFoodList();
        }, 1000);
      } else {
        console.error('出餐API调用失败:', response);
        alert(`出餐失败：${response.msg || '未知错误'}`);
      }
    } catch (error) {
      console.error('出餐异常:', error);
      alert('出餐失败：网络异常，请稍后重试');
    } finally {
      servingIds.value.delete(order.id);
    }
  }

  function closeReceiptModal() {
    showReceiptModal.value = false;
  }

  function printReceipt() {
    if (!receiptOrder.value) return;
    const printContent = `
    <div class='receipt-header'>
      <div class='receipt-title' style='font-size: 22px; font-weight: bold; margin-bottom: 10px;'>出菜小票</div>
    </div>
    <div class='receipt-item' style='margin-bottom: 18px;'>
      <span style='font-size: 22px; font-weight: bold;'>${receiptOrder.value.dishName}</span>
    </div>
    <div class='receipt-item' style='margin-bottom: 18px;'>
      <span style='font-size: 22px; font-weight: bold;'>${receiptOrder.value.table}</span>
    </div>
    <div class='receipt-item'>
      <span>灶台:</span>
      <span style='font-size: 16px; font-weight: 600;'>${receiptOrder.value.stove}</span>
    </div>
    <div class='receipt-item'>
      <span>备注:</span>
      <span style='font-size: 16px; font-weight: 600;'></span>
    </div>
    <div class='receipt-item'>
      <span>出菜时间:</span>
      <span style='font-size: 16px; font-weight: 600;'>${receiptOrderTime.value}</span>
    </div>
  `;
    const printWindow = window.open('', '_blank');
    printWindow?.document.write(`<!DOCTYPE html>
<html>
<head>
  <title>出菜小票</title>
  <style>
    body { font-family: 'Courier New', monospace; font-size: 16px; margin: 20px; }
    .receipt-header { text-align: center; border-bottom: 2px dashed #000; padding-bottom: 10px; margin-bottom: 15px; }
    .receipt-title { font-size: 22px; font-weight: bold; margin-bottom: 10px; }
    .receipt-item { display: flex; justify-content: space-between; margin-bottom: 18px; }
    .receipt-item span:first-child { font-size: 22px; font-weight: bold; }
    .receipt-item span:last-child { font-size: 22px; font-weight: bold; }
  </style>
</head>
<body>
  ${printContent}
</body>
</html>
`);
    printWindow?.document.close();
    printWindow?.print();
    printWindow?.close();
  }

  // 刷新菜品列表
  const refreshDishes = () => {
    loadFoodList();
    updateRefreshTime(); // 新增：更新时间
    showToast('菜品列表已刷新');
  };

  // 新增：更新刷新时间
  const updateRefreshTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    lastRefreshTime.value = `${hours}:${minutes}:${seconds}`;
  };

  // 新增：启动自动刷新定时器
  const startAutoRefresh = () => {
    // 清除现有定时器
    if (autoRefreshTimer) {
      clearInterval(autoRefreshTimer);
    }

    // 设置10秒定时器
    autoRefreshTimer = setInterval(async () => {
      if (currentKitchen.value) {
        await loadFoodList();
        updateRefreshTime();
        console.log('自动刷新完成:', lastRefreshTime.value);
      }
    }, 10000); // 10秒
  };

  // 新增：停止自动刷新定时器
  const stopAutoRefresh = () => {
    if (autoRefreshTimer) {
      clearInterval(autoRefreshTimer);
      autoRefreshTimer = null;
    }
  };

  // 显示提示消息
  const showToast = (message: string) => {
    // 创建提示框
    const toast = document.createElement('div');
    toast.className =
      'fixed top-4 right-4 bg-gray-900 text-white px-4 py-2 rounded-lg z-50 transform translate-x-full transition-transform duration-300';
    toast.textContent = message;
    document.body.appendChild(toast);

    // 显示动画
    setTimeout(() => {
      toast.classList.remove('translate-x-full');
    }, 100);

    // 自动隐藏
    setTimeout(() => {
      toast.classList.add('translate-x-full');
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 300);
    }, 2000);
  };

  // 新增：点击外部关闭菜单
  const handleClickOutside = (event: Event) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-dropdown')) {
      showNavMenu.value = false;
    }
  };

  // 生命周期钩子
  onMounted(() => {
    loadShops();
    // 新增：初始化刷新时间并启动自动刷新
    updateRefreshTime();
    startAutoRefresh();
    initNewOrderAudio(); // 初始化新订单提示音
    // 添加点击外部关闭菜单的事件监听
    document.addEventListener('click', handleClickOutside);
  });

  watch(
    selectionVersion,
    () => {
      servingItems.value = [];
      showReceiptModal.value = false;
    },
    { flush: 'sync' },
  );

  // 监听厨房变化
  watch(currentKitchen, (newVal) => {
    if (newVal) {
      // 保存当前选择的厨房到localStorage
      loadFoodList();
      // 新增：厨房变化时更新时间
      updateRefreshTime();
    }
  });

  // 新增：组件卸载时清理定时器
  onUnmounted(() => {
    stopAutoRefresh();
    newOrderAudio = null;
    // 移除事件监听器
    document.removeEventListener('click', handleClickOutside);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "title" }, "厨房出菜", -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentShop) ? (currentShop).value = $event : null)),
            class: "restaurant-select",
            disabled: ""
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("option", {
              value: "",
              disabled: ""
            }, "请选择餐厅", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shops), (shop) => {
              return (_openBlock(), _createElementBlock("option", {
                key: shop.shopId,
                value: String(shop.shopId)
              }, _toDisplayString(shop.shopName), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(currentShop)]
          ]),
          (_unref(selectionMessage))
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(selectionMessage)), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentKitchen) ? (currentKitchen).value = $event : null)),
            disabled: _unref(selectionLoading) || !_unref(kitchens).length,
            class: "restaurant-select"
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("option", {
              value: "",
              disabled: ""
            }, "请选择厨房", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("option", { value: "all" }, "全部厨房", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(kitchens), (kitchen) => {
              return (_openBlock(), _createElementBlock("option", {
                key: kitchen.id,
                value: kitchen.id
              }, _toDisplayString(kitchen.name), 9, _hoisted_8))
            }), 128))
          ], 8, _hoisted_7), [
            [_vModelSelect, _unref(currentKitchen)]
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(totalDishes.value), 1),
            _cache[5] || (_cache[5] = _createTextVNode("道菜品待出菜 ", -1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-clock mr-2" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(lastRefreshTime.value || '未刷新'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "nav-menu-btn",
              onClick: toggleNavMenu
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fas fa-bars" }, null, -1),
              _createTextVNode(" 菜单 ", -1),
              _createElementVNode("i", { class: "fas fa-chevron-down" }, null, -1)
            ])),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-menu", { show: showNavMenu.value }])
            }, [
              _createElementVNode("button", {
                class: "nav-menu-item",
                onClick: goToDishAssignment
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "fas fa-tasks" }, null, -1),
                _createTextVNode(" 菜品分配 ", -1)
              ])),
              _createElementVNode("button", {
                class: "nav-menu-item",
                onClick: goToKitchenOrder
              }, _cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "fas fa-utensils" }, null, -1),
                _createTextVNode(" 订单出餐 ", -1)
              ])),
              _createElementVNode("button", {
                class: "nav-menu-item",
                onClick: goToServingHistory
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "fas fa-history" }, null, -1),
                _createTextVNode(" 出餐历史 ", -1)
              ])),
              _createElementVNode("button", {
                class: "nav-menu-item",
                onClick: goToOrderHistory
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "fas fa-receipt" }, null, -1),
                _createTextVNode(" 订单查询 ", -1)
              ])),
              _createElementVNode("button", {
                class: "nav-menu-item",
                onClick: goToTableManage
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "fas fa-table" }, null, -1),
                _createTextVNode(" 桌位管理 ", -1)
              ]))
            ], 2)
          ]),
          _createElementVNode("button", {
            class: "refresh-btn",
            onClick: refreshDishes
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("i", { class: "fas fa-sync-alt" }, null, -1),
            _createTextVNode(" 刷新 ", -1)
          ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, (item) => {
          return _createElementVNode("button", {
            key: item.value,
            class: _normalizeClass(["sort-btn", { active: currentSortBy.value === item.value }]),
            onClick: ($event: any) => (changeSort(item.value))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(item.icon)
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(item.label), 1)
          ], 10, _hoisted_14)
        }), 64))
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedDishes.value, (dish) => {
          return (_openBlock(), _createElementBlock("div", {
            key: dish.key,
            class: _normalizeClass(["dish-card", [dishCardClass(dish)]])
          }, [
            _createElementVNode("div", _hoisted_16, [
              (currentSortBy.value === 'order')
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(dish.table), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[15] || (_cache[15] = _createTextVNode(" 订单号：", -1)),
                      _createElementVNode("span", null, _toDisplayString(String(dish.orderNo || dish.orderId || '').slice(0, -4)), 1),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(String(dish.orderNo || dish.orderId || '').slice(-4)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-clock" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(getElapsedTime(dish.orderTime || '')), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(dish.name), 1)
                  ])),
              _createElementVNode("div", _hoisted_24, [
                (currentSortBy.value === 'order' && dish.orders[0].dineType)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(getDineTypeText(dish.orders[0].dineType)), 1))
                  : _createCommentVNode("", true),
                (dish.orders.some((o) => o.isUrgent))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _cache[17] || (_cache[17] = [
                      _createElementVNode("i", {
                        class: "fas fa-fire",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" 加急 ", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dish.orders, (order) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: order.id,
                  class: _normalizeClass(["order-row", { urgent: order.isUrgent }])
                }, [
                  (order.imageUrl && !failedImageIds.value.has(order.id))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: order.imageUrl,
                        alt: order.name,
                        class: "serving-food-image",
                        loading: "lazy",
                        onError: ($event: any) => (failedImageIds.value.add(order.id))
                      }, null, 40, _hoisted_28))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      (currentSortBy.value !== 'order')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", _hoisted_31, _toDisplayString(order.table), 1),
                            (order.dineType)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(getDineTypeText(order.dineType)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, [
                              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-clock" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(getElapsedTime(order.orderTime)), 1)
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(order.kitchenName || '未知厨房'), 1),
                      (order.stove && order.stove !== '未知灶台')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(order.stove), 1))
                        : _createCommentVNode("", true),
                      (order.selfPickDate || order.selfPickTime)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(order.selfPickDate) + " " + _toDisplayString(order.selfPickTime), 1))
                        : _createCommentVNode("", true),
                      (order.isUrgent || order.priority >= 666 || !isServingPaused(order))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 3,
                            class: _normalizeClass(["serving-operation", {
                      'is-urgent': order.isUrgent,
                      'is-called': !order.isUrgent && order.priority >= 666,
                    }])
                          }, [
                            (order.isUrgent)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                              : (order.priority >= 666)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                                : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(order.isUrgent ? '加急' : order.priority >= 666 ? '叫菜' : '普通'), 1)
                          ], 2))
                        : _createCommentVNode("", true),
                      (isServingPaused(order))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                            _cache[19] || (_cache[19] = _createElementVNode("i", {
                              class: "fas fa-pause-circle",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(order.operateStatus === 1 ? '服务员暂停' : '厨师暂停'), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      (currentSortBy.value === 'order')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(order.name), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_40, "× " + _toDisplayString(order.quantity), 1),
                      (order.foodSpecName && order.foodSpecName !== '标准')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(order.foodSpecName), 1))
                        : _createCommentVNode("", true),
                      (order.foodCookDesc?.trim())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(order.foodCookDesc), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("button", {
                      class: "action-btn serve-btn",
                      disabled: order.operateStatus === 1 || servingIds.value.has(order.id),
                      title: order.operateStatus === 1 ? '服务员已暂停，恢复后可出菜' : '出菜',
                      onClick: ($event: any) => (serveOrder(order))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(order.operateStatus === 1 ? 'fas fa-pause' : 'fas fa-utensils')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(order.operateStatus === 1
                      ? '已暂停'
                      : servingIds.value.has(order.id)
                      ? '出餐中...'
                      : '出菜'), 1)
                    ], 8, _hoisted_44)
                  ])
                ], 2))
              }), 128))
            ])
          ], 2))
        }), 128))
      ], 512), [
        [_vShow, dishesData.value.length > 0]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_45, _cache[20] || (_cache[20] = [
        _createElementVNode("i", { class: "fas fa-utensils" }, null, -1),
        _createElementVNode("h3", null, "暂无待出菜品", -1),
        _createElementVNode("p", null, "所有菜品都已完成出菜", -1)
      ]), 512), [
        [_vShow, dishesData.value.length === 0]
      ])
    ])
  ]))
}
}

})